import { useMemo } from 'react';

const useMemoProps = <T>(props: T): T => useMemo(() => props, Object.values(props));

export default useMemoProps;
